import * as React from 'react'

import { Button } from '@/components/ui/button'
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer'
import { cn } from '@/lib/utils'
import { LineChart as LineChartIcon } from 'lucide-react'

export const ChartCodeViewer = ({
  className,
  children,
  triggerButton,
  open,
  onOpenChange,
  hideButton = false,
}) => {
  const button = (
    <Button variant="outline">
      <LineChartIcon className="w-4 h-4" />
      Chart
    </Button>
  )

  const content = (
    <div className="chart-wrapper w-full [&>div]:rounded-none [&>div]:border-0 [&>div]:border-b [&>div]:shadow-none [&_[data-chart]]:w-full [&_[data-chart]]:max-h-[50vh]">
      {children}
    </div>
  )

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      {!hideButton && (
        <DrawerTrigger asChild>{triggerButton || button}</DrawerTrigger>
      )}
      <DrawerContent
        className={cn(
          'flex max-h-[80vh] flex-col sm:max-h-[90vh] [&>div.bg-muted]:shrink-0',
          className,
        )}
      >
        <DrawerHeader className="hidden">
          <DrawerTitle>Roi Chart</DrawerTitle>
          <DrawerDescription>some chart</DrawerDescription>
        </DrawerHeader>
        <div className="flex h-full w-full flex-col overflow-auto px-4">
          {content}
        </div>
      </DrawerContent>
    </Drawer>
  )
}
